<template>
  <iframe
    v-if="iframeSrc"
    class="cs-badge-iframe"
    :src="iframeSrc"
    title="客服消息提醒"
    frameborder="0"
    tabindex="-1"
    aria-hidden="true"
  />
</template>

<script>
import { getWorkbenchInit } from '@/api/customer-service/order'
import { csEmbedIndexUrl, csEmbedStaticUrl } from '@/utils/csEmbed'

const CS_AGENT_KEY = 'CS_AGENT_INIT'
const CS_SHOP_KEY = 'CS_SHOP_INIT'
const CS_ADMIN_MODE_KEY = 'CS_ADMIN_MODE'
const DEFAULT_CS_AVATAR = csEmbedStaticUrl('images/Avatar-5.png')
const DEFAULT_SHOP_AVATAR = csEmbedStaticUrl('images/shop1.png')

function resolveWorkbenchAvatar(url, fallback) {
  if (!url || String(url).trim() === '' || url === 'null') {
    return fallback
  }
  const s = String(url).trim()
  if (s.startsWith('http://') || s.startsWith('https://') || s.startsWith('/')) {
    return s
  }
  return fallback
}

export default {
  name: 'CsMenuBadgeIframe',
  data() {
    return {
      iframeSrc: ''
    }
  },
  mounted() {
    this.initIframe()
  },
  methods: {
    initIframe() {
      getWorkbenchInit().then(res => {
        const d = res.data || {}
        if (!d.csAgentId || !d.shopId) {
          return
        }
        sessionStorage.setItem(CS_AGENT_KEY, JSON.stringify({
          id: d.csAgentId,
          name: d.agentName || '客服',
          avatar: resolveWorkbenchAvatar(d.agentAvatar, DEFAULT_CS_AVATAR),
          shopId: d.shopId,
          adminMode: !!d.adminMode
        }))
        sessionStorage.setItem(CS_ADMIN_MODE_KEY, d.adminMode ? '1' : '0')
        sessionStorage.setItem(CS_SHOP_KEY, JSON.stringify({
          id: d.shopId,
          name: d.shopName,
          avatar: DEFAULT_SHOP_AVATAR
        }))
        this.iframeSrc = csEmbedIndexUrl('#/conversations')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.cs-badge-iframe {
  position: fixed;
  width: 0;
  height: 0;
  border: 0;
  opacity: 0;
  pointer-events: none;
  z-index: -1;
}
</style>
